<template>
  <div>
    <div class="intro-y flex flex-col sm:flex-row items-center mt-8">
      <UserCheckIcon />
      <h2 class="text-lg font-medium mr-auto">{{ $t('admin.list') }}</h2>
      <div class="w-full sm:w-auto flex mt-4 sm:mt-0">
        <router-link :to="{ name: 'side-menu-admins-add' }">
          <button class="btn btn-primary shadow-md mr-2">
            {{ $t('admin.add') }}
          </button>
        </router-link>
      </div>
    </div>
    <!-- BEGIN: HTML Table Data -->
    <div class="intro-y box p-5 mt-5">
      <ListTable />
    </div>
    <!-- END: HTML Table Data -->
  </div>
</template>

<script>
import { defineComponent } from 'vue'
import ListTable from '@/components/admin-users/ListTable'

export default defineComponent({
  components: {
    ListTable
  },
  setup() {
    return {}
  }
})
</script>
